// extracted by mini-css-extract-plugin
export default {"stickyBtnWrap":"Style_stickyBtnWrap__oVjMU","upperWrap":"Style_upperWrap__qU7DW","upperNum":"Style_upperNum__HM098","btnWrap":"Style_btnWrap__kwqXZ","edit":"Style_edit__q2aqm"};